import dayjs from "dayjs";

// used for ISO 8601 duration strings
import duration from "dayjs/plugin/duration";
dayjs.extend(duration);

export default dayjs;
